jQuery(function ($) {

  $('html').removeClass('no-js').addClass('js');


  if ( $( "#stick-menu" ).length ) {
    
    var menu = $('#stick-menu');
    var tab = $('.tab-content');
    var origOffsetY = menu.offset().top;
    var hash = window.location.hash;

    hash && $( 'ul.nav a[href="' + hash + '"]').tab( 'show');
    document.onscroll = scroll;

    $( '.nav-tabs a').click(function (e) {
      $(this).tab('show');
      window.location.hash = this.hash;
    });

  }

  function scroll() {
    $( window ).scrollTop() >= origOffsetY ? menu.addClass( 'sticky' ) : menu.removeClass( 'sticky' );
    $( window ).scrollTop() >= origOffsetY ? tab.addClass( 'tab-padding' ) : tab.removeClass( 'tab-padding' );
  }

  var stopVideo = function(player) {
    var iframe = player.find('iframe');
    var src = iframe.prop('src');
    console.log(src);
    iframe.prop('src', '');
    iframe.prop('src', src);
  };

  $( '[data-video="show"]' ).click(function() {
    var $video = $('#video-'+$(this).attr('data-target'));
    var $hide = $('#hide-video-'+$(this).attr('data-target'));
    $video.fadeIn();
    $('.carousel').carousel('pause');
    $hide.fadeIn();
    $('.carousel-control').fadeOut();
  });

  $( '[data-video="hide"]' ).click(function() {
    var $video = $('#video-'+$(this).attr('data-target'));
    var $hide = $('#hide-video-'+$(this).attr('data-target'));
    $video.fadeOut();
    $('.carousel').carousel('cycle');
    $hide.fadeOut();
    stopVideo($video);
    $('.carousel-control').fadeIn();
  });

  lightbox.option({
    'disableScrolling': true,
    'showImageNumberLabel': false,
    'wrapAround': true,
    'fadeDuration': 400,
    'resizeDuration': 400
  });

  (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
  })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
  ga('create', 'UA-35542896-3', 'auto');
  ga('send', 'pageview');

});
